export default __webpack_public_path__ + "static/media/info-icon-outline-grey.d4dde44e.svg";